var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// C:/angular/aws-lex-web-ui-master/aws-lex-web-ui-master/node_modules/asn1.js/lib/asn1/decoders/index.js
// module id = ../../../node_modules/asn1.js/lib/asn1/decoders/index.js
// module chunks = 0